import {
  Text,
  GreyGrey80,
  Primary13Regular,
  SimpleModal
} from '@sequencehq/core-components'
import { FC } from 'react'

type ConfirmDeleteLatestQuoteDraftModalProps = {
  onClose: () => void
  onConfirm: () => void
  submitting: boolean
}

export const ConfirmDeleteLatestQuoteDraftModal: FC<
  ConfirmDeleteLatestQuoteDraftModalProps
> = props => {
  return (
    <SimpleModal
      isOpen
      data-testid="quote.modals.deleteLatestDraft"
      variant="dialog"
      dialogPosition="top"
      width="414px"
      title="Delete draft changes"
      onClose={props.onClose}
      onSubmit={() => {
        props.onConfirm()
        // The parent owns the modal lifecycle: it unmounts this modal once the
        // delete completes, so keep it open with the submitting spinner here.
        return false
      }}
      isDestructive
      disableSubmitOnEnter
      submitButtonText="Delete"
      submittingButtonText="Delete"
      cancelButtonText="Cancel"
      submitting={props.submitting}
    >
      <Text {...Primary13Regular} color={GreyGrey80}>
        You’re about to delete your draft changes. The quote will revert to the
        latest published variant.
      </Text>
    </SimpleModal>
  )
}
